"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformationPanel = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../utils/index.js");
require("@itwin/itwinui-css/css/information-panel.css");
/**
 * InformationPanel provides a way to view additional content or attributes
 * without leaving the main content area (e.g. Table).
 *
 * The panel appears as an overlay on top of the main content.
 * @example
 * <InformationPanelWrapper>
 *   <Table ... /> // component to overlay
 *   <InformationPanel isOpen={true}>
 *     <InformationPanelHeader onClose={() => {}}>
 *       <Text variant='subheading'>InfoPanel heading</Text>
 *     </InformationPanelHeader>
 *     <InformationPanelBody>
 *       <Text>Metadata</Text>
 *       <InformationPanelContent ... />
 *       <Text>Attributes</Text>
 *       <InformationPanelContent ... />
 *     </InformationPanelBody>
 *   </InformationPanel>
 * </InformationPanelWrapper>
 */
exports.InformationPanel = React.forwardRef((props, ref) => {
    const { className, isOpen = false, orientation = 'vertical', resizable = true, children, ...rest } = props;
    (0, index_js_1.useTheme)();
    const infoPanelRef = React.useRef(null);
    const refs = (0, index_js_1.useMergedRefs)(ref, infoPanelRef);
    const startResize = (e) => {
        if (!infoPanelRef.current) {
            return;
        }
        if (e.button != undefined && e.button !== 0) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        infoPanelRef.current.ownerDocument.addEventListener('pointermove', onResize);
        infoPanelRef.current.ownerDocument.addEventListener('pointerup', () => {
            var _a;
            return (_a = infoPanelRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument.removeEventListener('pointermove', onResize);
        }, { once: true });
    };
    const onResize = React.useCallback((e) => {
        e.preventDefault();
        if (!infoPanelRef.current) {
            return;
        }
        const { right, bottom } = infoPanelRef.current.getBoundingClientRect();
        if (orientation === 'vertical') {
            infoPanelRef.current.style.width = `${right - e.clientX}px`;
        }
        else {
            infoPanelRef.current.style.height = `${bottom - e.clientY}px`;
        }
    }, [orientation]);
    return (React.createElement("div", { className: (0, classnames_1.default)('iui-information-panel', {
            'iui-right': orientation === 'vertical',
            'iui-bottom': orientation === 'horizontal',
            'iui-visible': isOpen,
        }, className), ref: refs, ...rest },
        resizable && (React.createElement("div", { className: 'iui-resizer', onPointerDown: startResize },
            React.createElement("div", { className: 'iui-resizer-bar' }))),
        children));
});
exports.default = exports.InformationPanel;
